"use client";

import { createContext, useMemo, type ReactNode } from "react";
import type { B2BBrandingConfig, ResolvedBranding } from "./types";
import { resolveBranding } from "./defaults";

export const BrandingContext = createContext<ResolvedBranding | null>(null);

/**
 * Provides the resolved tenant branding to client components. Fed the
 * server-resolved B2BBrandingConfig (or null) from the app's root layout.
 */
export function BrandingProvider({
  branding,
  children,
}: {
  branding: B2BBrandingConfig | null;
  children: ReactNode;
}) {
  const resolved = useMemo(() => resolveBranding(branding), [branding]);
  return (
    <BrandingContext.Provider value={resolved}>
      {children}
    </BrandingContext.Provider>
  );
}
